<style scoped="scoped" lang="scss">
/deep/ .info {
  display: flex;
  margin-left: 70px;

  //align-items: center;
  .info_item {
    flex: 1;
    max-width: 33.33%;
  }
}

._form /deep/ .el-input {
  min-width: 120px;
  height: 28px !important;
  width: 120px !important;
}

._form /deep/ .el-input__inner {
  height: 28px !important;
}

._form /deep/ .el-input__icon {
  line-height: 28px !important;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/in/order/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('rukudanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')">
            <!--						<yi_cross_select multiple :component="'web_wms_purchase_receipt_supplier_information'"-->
            <!--							:ids.sync="yt.conditions.supplierIds">-->
            <!--						</yi_cross_select>-->
            <el-select collapse-tags v-model="yt.conditions.supplierIds" filterable multiple>
              <el-option v-for="(item, index) in supplierList" :key="index" :label="item.supplierCodeName" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shenhezhuangtai')">
            <el-select v-model="yt.conditions.checkStatus">
              <el-option :label="$t('daishenhe')" :value="0"></el-option>
              <el-option :label="$t('yishenhe')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('danjuzhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('weiruku')" :value="0"></el-option>
              <el-option :label="$t('bufenruku')" :value="1"></el-option>
              <el-option :label="$t('quanburuku')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('danjuriqi')">
            <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="yt.conditions.billDate"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc', type: 1 })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w2', beforeShowEditDialog)" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->
      <!--单据类型-->
      <template #danjuleixing="scope">
        <span v-if="scope.row.type === 1">{{ $t('wudanruku') }}</span>
      </template>
      <!--审核状态-->
      <template #shenhezhuangtai="scope">
        <span v-if="scope.row.checkStatus === 0">{{ $t('daishenhe') }}</span>
        <span v-if="scope.row.checkStatus === 1">{{ $t('yishenhe') }}</span>
      </template>
      <!--单据状态-->
      <template #danjuzhuangtai="scope">
        <span v-if="scope.row.status === 0">{{ $t('weiruku') }}</span>
        <span v-if="scope.row.status === 1">{{ $t('bufenruku') }}</span>
        <span v-if="scope.row.status === 2">{{ $t('quanburuku') }}</span>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.checkStatus === 0">
            <el-popconfirm :title="$t('quedingshenheshuju?')" @confirm="examine(scope.row)">
              <el-button v-if="utils.checkPower('web_wms_receipt_without_order_check_button')" type="text" slot="reference">{{ $t('shenhe') }}</el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.checkStatus === 0">
            <el-button type="text" @click="showUpdateDialog(scope.row, 'w2')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.checkStatus === 1">
            <el-button type="text" v-if="utils.checkPower('web_wms_receipt_without_order_view_button')" @click="yt.showEditDialog('chakan', scope.row, '80%')">
              {{ $t('chakan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.checkStatus === 1 && (scope.row.status === 0 || scope.row.status === 1)">
            <el-button type="text" v-if="utils.checkPower('web_wms_receipt_without_order_putIn_kaisu')" @click="yt.showEditDialog('ruku', scope.row, '80%')">
              {{ $t('ruku') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status === 2 || scope.row.status === 1">
            <el-button class="font-color-danger" type="text" v-if="utils.checkPower('web_wms_receipt_without_order_quash')" @click="quash(scope.row)">
              {{ $t('chexiao') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.checkStatus === 1 && scope.row.status === 2">
            <el-popover placement="top" width="200" trigger="click">
              <el-button @click="printDefault(scope.row)" type="text">
                {{ $t('morenmoban') }}
              </el-button>
              <el-button @click="yt.showEditDialog('dayin', scope.row, '80%')" type="text">
                {{ $t('qitamoban') }}
              </el-button>
              <el-button slot="reference" type="text">
                {{ $t('dayin') }}
              </el-button>
            </el-popover>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.checkStatus === 0">
            <el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_wms_receipt_without_order_delete_button')" @click="yt.remove(scope.row, '/web/in/order/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.checkStatus === 1 && scope.row.status === 0">
            <el-popconfirm :title="$t('quedingbohuishuju?')" @confirm="reject(scope.row)">
              <el-button v-if="utils.checkPower('web_wms_receipt_without_order_back_button')" :loading="yt.editObj.loading" type="text" slot="reference">{{ $t('shenhebohui') }}</el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div style="margin-top: 8px;margin-left: 56px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
          {{ $t('rukudantouxinxi') }}
        </div>
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
            <el-form-item :label="$t('gongyingshangmingcheng')">
              <el-select v-model="yt.editObj.supplierId" clearable filterable>
                <el-option v-for="(item, index) in supplierList" :key="index" :label="item.supplierCodeName" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('kehumingcheng')">
              <el-select v-model="yt.editObj.wmsCustomerId" clearable filterable>
                <el-option v-for="(item, index) in customerList" :key="index" :label="item.customerCodeName" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <br />
            <el-form-item class="noborder" :label="$t('danjuleixing')" required>
              <el-select disabled v-model="yt.editObj.type" @change="$forceUpdate()">
                <el-option :label="$t('wudanruku')" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <br />
            <el-form-item :label="$t('danjuriqi')" required>
              <yi_time_input :is_current="true" :format="'yyyy-MM-dd'" type="date" :time.sync="yt.editObj.billDate"> </yi_time_input>
            </el-form-item>
            <br />
            <el-form-item :label="$t('beizhu')">
              <el-input v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top: 8px;margin-left: 56px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('rukudanmingxixinxi') }}
          </div>
          <div class="info">
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('wuliaobianma/mingcheng') }}</div>
            <div class="info_item">{{ $t('wuliaopicihao') }}</div>
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('danwei') }}</div>
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('rukushuliang') }}</div>
            <div class="info_item" v-if="colorNoEnable"><span style="color: #F56C6C">*</span>{{ $t('sehao') }}</div>
            <div class="info_item">{{ $t('beizhu') }}</div>
          </div>
          <div class="_form" style="margin-left: -25px;margin-top: 8px;">
            <div class="info" v-for="(item, index) in yt.editObj.inOrderDetailList">
              <div>
                <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(item)"> </el-button>
              </div>

              <div class="info_item">
                <yi_cross_select style="margin-left: 8px;" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="item.materialId" @getItems="changeMaterial(index, $event)" :key="item.tmpId"> </yi_cross_select>
              </div>
              <div class="info_item">
                <el-input type="text" size="mini" v-model="item.materialBatchNo"> </el-input>
              </div>
              <div class="info_item">
                <yi_dictionary_select :type="'UNIT_CONVERSION_TYPE'" :ids.sync="item.unit"> </yi_dictionary_select>
              </div>
              <div class="info_item">
                <el-input-number :precision="5" :step="0" :min="0" :controls="false" v-model="item.quantity" size="mini"> </el-input-number>
              </div>
              <div class="info_item" v-if="colorNoEnable">
                <yi_dictionary_select type="CUSTOMER_MATERIAL_COLOR_NO" :ids.sync="item.colorNo"> </yi_dictionary_select>
              </div>
              <div class="info_item">
                <el-input type="text" size="mini" v-model="item.remark"> </el-input>
              </div>
            </div>
            <div style="margin-left: 70px;">
              <el-button style="font-size: 14px" type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                {{ $t('zengjiayitiaorukuxinxi') }}
              </el-button>

              <el-button style="font-size: 14px" type="primary" size="mini" @click="isShowUploadDialog = true">
                {{ $t('daoru') }}
              </el-button>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" v-if="utils.checkPower('web_wms_receipt_without_order_add_button')" @click="yt.req('POST', '/web/in/order/insertOrderAndDetail', beforAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div style="margin-top: 8px;margin-left: 56px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
          {{ $t('rukudantouxinxi') }}
        </div>
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
            <el-form-item :label="$t('gongyingshangmingcheng')">
              <el-select v-model="yt.editObj.supplierId" clearable filterable>
                <el-option v-for="(item, index) in supplierList" :key="index" :label="item.supplierCodeName" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('kehumingcheng')">
              <el-select v-model="yt.editObj.wmsCustomerId" clearable filterable>
                <el-option v-for="(item, index) in customerList" :key="index" :label="item.customerCodeName" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <br />
            <el-form-item class="noborder" :label="$t('danjuleixing')" required>
              <el-select disabled v-model="yt.editObj.type" @change="$forceUpdate()">
                <el-option :label="$t('wudanruku')" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <br />
            <el-form-item :label="$t('danjuriqi')" required>
              <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="yt.editObj.billDate"> </yi_time_input>
            </el-form-item>
            <br />
            <el-form-item :label="$t('beizhu')">
              <el-input v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top: 8px;margin-left: 56px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('rukudanmingxixinxi') }}
          </div>
          <div class="info">
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('wuliaobianma/mingcheng') }}</div>
            <div class="info_item">{{ $t('wuliaopicihao') }}</div>
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('danwei') }}</div>
            <div class="info_item"><span style="color: #F56C6C">*</span>{{ $t('rukushuliang') }}</div>
            <div class="info_item" v-if="colorNoEnable"><span style="color: #F56C6C">*</span>{{ $t('sehao') }}</div>
            <div class="info_item">{{ $t('beizhu') }}</div>
          </div>
          <div v-loading="true" v-if="yt.editObj.isMaterialLoading == true" style="height: 80px;width:100%;"></div>
          <div class="_form" style="margin-left: -25px;margin-top: 8px" v-if="yt.editObj.showFlag">
            <div class="info" v-for="(item, index) in yt.editObj.inOrderDetailList" :key="index">
              <div>
                <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(item)"> </el-button>
              </div>
              <div class="info_item">
                <yi_cross_select :key="item.tmpId" style="margin-left: 8px;" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="item.materialId" :objs="item.materials" @getItems="changeMaterialUpdate(index, $event)"> </yi_cross_select>
              </div>
              <div class="info_item">
                <el-input type="text" size="mini" v-model="item.materialBatchNo"> </el-input>
              </div>
              <div class="info_item">
                <yi_dictionary_select :type="'UNIT_CONVERSION_TYPE'" :ids.sync="item.unit"> </yi_dictionary_select>
              </div>
              <div class="info_item">
                <el-input-number :precision="5" :step="0" :min="0" :controls="false" v-model="item.quantity" size="mini"> </el-input-number>
              </div>
              <div class="info_item" v-if="colorNoEnable">
                <yi_dictionary_select type="CUSTOMER_MATERIAL_COLOR_NO" :ids.sync="item.colorNo"> </yi_dictionary_select>
              </div>
              <div class="info_item">
                <el-input type="text" size="mini" v-model="item.remark"> </el-input>
              </div>
            </div>
            <div style="margin-left: 70px;">
              <el-button style="font-size: 14px" type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                {{ $t('zengjiayitiaorukuxinxi') }}
              </el-button>

              <el-button style="font-size: 14px" type="primary" size="mini" @click="isShowUploadDialog = true">
                {{ $t('daoru') }}
              </el-button>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" v-if="utils.checkPower('web_wms_receipt_without_order_edit_button')" @click="yt.req('POST', '/web/in/order/insertOrderAndDetail')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 查看-->
      <template v-if="yt.editObj.action == 'chakan'">
        <div class="dialog-scroller">
          <check_list :check="yt.editObj" :colorNoEnable="colorNoEnable"></check_list>
        </div>
      </template>
      <!-- 入库 -->
      <template v-if="yt.editObj.action === 'ruku'">
        <div class="dialog-scroller">
          <storage :row="yt.editObj" :colorNoEnable="colorNoEnable"></storage>
        </div>
      </template>
      <!-- 打印 -->
      <template v-if="yt.editObj.action == 'dayin'">
        <div class="dialog-scroller">
          <yi_cross_select :isShowButtons="false" :isShowCaoZuo="false" :isInput="false" :component="'web_base_print_list'" :type="'1'" :status="1" :max="1" :ids.sync="printId" @getItems="getPrint"> </yi_cross_select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yulan()" type="primary">
            {{ $t('yulan') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog :show-close="true" :visible.sync="isShowPrintDialog" :width="'960px'" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <template_without_in id="wmsPrintId" v-if="isShowPrintDialog" :config="currentPrint.config" :order="yt.editObj"> </template_without_in>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowPrintDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button size="mini" @click="dayin()" type="primary">
          {{ $t('dayin') }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="isShowUploadDialog" width="80%" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <importExcel v-if="isShowUploadDialog" ref="importExcel" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="isShowUploadDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" size="mini" @click="save()" :loading="yt.editObj.loading">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import html2canvas from 'html2canvas';
import print from 'print-js';
import template_without_in from '@@/pages/web/base/print/template_without_in';
import check_list from '@@/pages/web/wms/receipt_without_order/check/list';
import importExcel from '@@/pages/web/wms/receipt_without_order/import_excel.vue';
import storage from '@@/pages/web/wms/receipt_without_order/storage';

export default {
  name: 'web_wms_receipt_without_order_list',
  components: {
    importExcel,
    check_list,
    template_without_in,
    storage
  },
  data() {
    return {
      materialIds: [],
      printId: null,
      currentPrint: null,
      supplierList: [],
      customerList: [],
      isShowPrintDialog: false,
      colorNoEnable: false,
      columns: [
        {
          label: 'rukudanhao',
          prop: 'no',
          width: 150
        },
        {
          label: 'gongyingshangmingcheng',
          prop: 'supplier.name',
          width: 150
        },
        {
          label: 'kehumingcheng',
          prop: 'wmsCustomer.name',
          width: 150
        },
        {
          label: 'danjuleixing',
          type: 'slot',
          prop: 'type',
          width: 150
        },
        {
          label: 'shenhezhuangtai',
          prop: 'checkStatus',
          type: 'slot'
        },
        {
          label: 'danjuzhuangtai',
          prop: 'status',
          type: 'slot'
        },
        {
          label: 'danjuriqi',
          prop: 'billDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 100
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 150
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 150
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 150
        },
        {
          label: 'shenheren',
          prop: 'checkUserObject.nickname',
          width: 150
        },
        {
          label: 'shenheshijian',
          prop: 'checkTime',
          type: 'time',
          width: 150
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 200,
          fixed: 'right'
        }
      ],
      isShowUploadDialog: false
    };
  },
  watch: {
    'yt.isShowEditDialog': {
      handler(n, o) {
        if (n == false && this.yt.editObj.action === 'ruku') {
          this.yt.get();
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    this.getProductionConfig();
    setTimeout(() => {
      this.getSupplierList();
      this.yt.conditions = {
        //表格默认按照创建时间降序排序。
        orderBy: 'createTime desc',
        type: 1
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    showUpdateDialog(row) {
      const ids = row.inOrderDetailList.map(item => item.materialId);
      this.http
        .get('/web/basic/material/getMaterialByIds', {
          params: {
            ids: ids
          }
        })
        .then(res => {
          let materials = res.data;
          row.inOrderDetailList.forEach(item => {
            const material = materials.find(m => m.id === item.materialId);
            this.$set(item, 'materials', [material]);
          });
          this.$set(row, 'isMaterialLoading', true);
          this.yt.showEditDialog('bianji', row, '900px');
          setTimeout(() => {
            this.$set(this.yt.editObj, 'showFlag', true);
            this.$set(this.yt.editObj, 'isMaterialLoading', false);
          }, 300);
        });

      this.getSupplierList();
      this.getCustomerList();
    },

    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
      });
    },
    // 获取供应商编码、名称
    async getSupplierList() {
      return await this.http
        .get(
          '/web/supplier/page?' +
            this.qs.stringify({
              pageNum: 1,
              pageSize: 999
              // orderBy: 'sort',
            })
        )
        .then(response => {
          this.supplierList = response.data.rows || [];
          for (let i = 0; i < this.supplierList.length; i++) {
            const supplierCodeName = this.supplierList[i]['code'] + '/' + this.supplierList[i]['name'];
            this.$set(this.supplierList[i], 'supplierCodeName', supplierCodeName);
          }
          console.log('this.supplierList', this.supplierList);
        });
    },
    // 获取客户编码、名称
    async getCustomerList() {
      return await this.http
        .get(
          '/web/wms/customer/page?' +
            this.qs.stringify({
              pageNum: 1,
              pageSize: 999
              // orderBy: 'sort',
            })
        )
        .then(response => {
          this.customerList = response.data.rows || [];
          for (let i = 0; i < this.customerList.length; i++) {
            const customerCodeName = this.customerList[i]['code'] + '/' + this.customerList[i]['name'];
            this.$set(this.customerList[i], 'customerCodeName', customerCodeName);
          }
          console.log('this.customerList', this.customerList);
        });
    },
    /**
     * 物料选中后回调
     * @param index 当前行
     * @param item 选中后的项目
     */
    changeMaterial(index, item) {
      this.$set(this.yt.editObj.inOrderDetailList[index], 'unit', item.defaultUnit || '');
    },
    changeMaterialUpdate(index, item) {
      this.$set(this.yt.editObj.inOrderDetailList[index], 'unit', item.defaultUnit || '');
    },
    beforAdd(params) {
      params.wmsCustomerId = parseInt(params.wmsCustomerId);
      return params;
    },
    //审核
    examine(editObj) {
      this.http
        .post('/web/in/order/check', {
          id: editObj.id
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    //驳回
    reject(editObj) {
      this.http
        .post('/web/in/order/reject', {
          id: editObj.id
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    setDefaultValue(editObj) {
      editObj.type = 1;
    },
    //增加一条出库信息
    addItem() {
      console.log('this.yt.editObj.inOrderDetailList', this.yt.editObj.inOrderDetailList);
      this.yt.editObj.inOrderDetailList.push({
        tmpId: new Date().getTime(),
        materialId: '',
        materialBatchNo: '',
        unit: '',
        quantity: undefined,
        remark: ''
      });
    },
    //减少一条出库信息
    deleteItem(item) {
      var index = this.yt.editObj.inOrderDetailList.indexOf(item);
      if (index !== -1) {
        this.yt.editObj.inOrderDetailList.splice(index, 1);
      }
    },
    beforeShowEditDialog(editObj) {
      console.log('editObj', editObj);
      if (editObj.action === 'xinzeng') {
        editObj.inOrderDetailList = [
          {
            materialId: '',
            materialBatchNo: '',
            unit: '',
            quantity: undefined,
            remark: ''
          }
        ];
        this.setDefaultValue(editObj);
        this.getSupplierList();
        this.getCustomerList();
      }
      return editObj;
    },
    yulan() {
      if (!this.currentPrint) {
        return this.$message.warning(this.$t('qingxuanzemoban'));
      }
      this.http
        .get('/web/in/order/detail/page?pageNum=1&pageSize=1000', {
          params: {
            inOrderId: this.yt.editObj.id
          }
        })
        .then(res => {
          console.log(res);
          this.yt.editObj.details = res.data.rows;
          this.isShowPrintDialog = true;
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    dayin() {
      html2canvas(document.getElementById('wmsPrintId'), { scale: 8 }).then(async canvas => {
        const imgData = canvas.toDataURL('image/png');
        print({
          printable: imgData,
          type: 'image',
          documentTitle: '',
          modalMessage: this.$t('zhengzaijiazaiwenjian,qingshaohou')
          // footer: "My Footer Text"
        });

        // 新增打印记录
        const inOrderNo = this.yt.editObj.no;
        let data = {
          inOrderNo: inOrderNo,
          businessType: '9',
          templateId: this.currentPrint.id
        };
        const res = await this.http.post('/web/print/record/createPrintRecord', data);
        if (res.code === 200) {
          this.yt.isShowEditDialog = false;
          this.isShowPrintDialog = false;
        }
      });
    },

    getPrint(item) {
      this.currentPrint = item;
      console.log(item);
    },

    printDefault(row) {
      this.yt.editObj = this.utils.copy(row);

      this.http
        .get('/web/printConfig/page?pageNum=1&pageSize=1000', {
          params: {
            type: 1,
            isDefault: 1
          }
        })
        .then(res => {
          console.log(res);
          if (res.data.rows.length == 0) {
            this.utils.errorMessage(this.$t('meiyoudayinmoban'));
            return;
          }
          this.currentPrint = res.data.rows[0];
          this.yulan();
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    save() {
      this.yt.editObj.loading = true;
      let importData = this.$refs.importExcel.convertData;
      console.log(this.materialIds);
      this.isShowUploadDialog = false;
      if (importData && importData.length > 0) {
        if (this.yt.editObj.action === 'xinzeng') {
          this.yt.editObj.inOrderDetailList = [];
          this.$nextTick(() => {
            importData.forEach(item => {
              item.materialId = Number(item.materialId);
            });
            //拿到id数组，然后去获取objs
            const ids = importData.map(item => item.materialId);
            this.http
              .get('/web/basic/material/getMaterialByIds', {
                params: {
                  ids: ids
                }
              })
              .then(res => {
                console.log(res);
                //把res.data.rows赋值给importData的material字段
                importData.forEach(item => {
                  const material = res.data.find(m => m.id === item.materialId);
                  console.log(material);
                  item.materials = [material];
                });

                this.yt.editObj.inOrderDetailList = importData;
                this.yt.editObj.loading = false;
              });
          });
        } else if (this.yt.editObj.action === 'bianji') {
          this.$nextTick(() => {
            importData.forEach(item => {
              item.materialId = Number(item.materialId);
            });

            const ids = importData.map(item => item.materialId);
            this.http
              .get('/web/basic/material/getMaterialByIds', {
                params: {
                  ids: ids
                }
              })
              .then(res => {
                console.log(res);
                //把res.data.rows赋值给importData的material字段
                importData.forEach(item => {
                  const material = res.data.find(m => m.id === item.materialId);
                  item.materials = [material];
                  this.yt.editObj.inOrderDetailList.push(item);
                  this.yt.editObj.loading = false;
                });
              });
          });
        }
      }
    },
    quash(row) {
      // 使用Vue.js的$confirm方法创建确认框
      this.$confirm(this.$t('shifouchexiaodangqianjilu'), this.$t('tishi'), {
        confirmButtonText: this.$t('chexiao'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      })
        .then(() => {
          const param = row;
          // 如果用户点击了确认按钮，则执行撤销操作
          this.http
            .post('/web/in/order/quash', param)
            .then(res => {
              this.utils.successMessage(this.$t('caozuochenggong'));
              this.yt.get(1);
            })
            .catch(err => {
              this.utils.errorMessage(err);
              this.stopRepairLoading = false;
            });
        })
        .catch(() => {
          // 如果用户点击了取消按钮，则不执行任何操作
          alert('已取消撤销操作！');
        });
    }
  }
};
</script>
